/**
 * FileInput — hidden file input for arbitrary accepted file types.
 *
 * Used by SkillFormDialog (F-SKILL-1 B2) to attach reference files
 * (PDF, Word, plain text, Markdown). Wraps the raw <input> so the
 * roros/no-raw-html ESLint rule stays satisfied.
 */

import React from 'react';

export interface FileInputProps {
  /** Ref forwarded to the hidden <input> element for programmatic .click(). */
  inputRef: React.RefObject<HTMLInputElement | null>;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  accept?: string;
  'data-testid'?: string;
  'aria-label'?: string;
}

export function FileInput({
  inputRef,
  onChange,
  accept,
  'data-testid': testId,
  'aria-label': ariaLabel,
}: FileInputProps) {
  return (
    <input
      ref={inputRef}
      type="file"
      accept={accept}
      className="sr-only"
      aria-hidden={!ariaLabel}
      aria-label={ariaLabel}
      tabIndex={-1}
      onChange={onChange}
      data-testid={testId}
    />
  );
}
